jQuery(document).ready(function() {


	console.log("test header");

    // wave errors
    
    jQuery('.social-media__item a').removeAttr("aria-describedby");
	jQuery('a[href="mailto:support@bidetking.com"]').removeAttr("aria-describedby");

    jQuery(document).ready(function ($) {
    $('[aria-describedby="a11y-new-window-message"]').removeAttr('aria-describedby');
    });    

    jQuery(document).ready(function ($) {
    $('#a11y-zoom-dialog img').attr('alt', 'Full-size product image');
    });

    jQuery('.header__action-item-link.header__cart-toggle').attr("role","button");
    jQuery('#mini-cart').attr("role","dialog");
    jQuery('#mini-cart').attr("aria-modal","true");
    jQuery('.collection-list.flickity-enabled, .product-list.product-list--scrollable.flickity-enabled').removeAttr("tabindex");
    jQuery('.product-form__add-button.button.button--primary').attr("aria-haspopup","dialog");
    jQuery('.product-form__add-button.button.button--primary').attr("aria-haspopup","dialog");
	jQuery('a[href="mailto:support@bidetking.com"]').attr('aria-label', 'Email us at support@bidetking.com');
	jQuery('a[href="mailto:support@bidetking.com"]').removeAttr('title');
	jQuery('.social-media__item-list.list--unstyled').removeAttr('role');
    jQuery('#refersion-iframe-goes-here iframe').attr("title","Affiliate program form");
    jQuery('.product-form__info-content a').attr("role","button");
    jQuery('.quantity-selector__button').removeAttr("title");
    jQuery('.product-item__image-wrapper.product-item__image-wrapper--with-secondary, .product-item__vendor.link').attr("tabindex","-1");

    jQuery('#tmenu-submenu-5 a:eq(0)').attr("aria-label","Alpha Bidet");
    jQuery('#tmenu-submenu-5 a:eq(1)').attr("aria-label","BidetKing");
    jQuery('#tmenu-submenu-5 a:eq(2)').attr("aria-label","Bio Bidet");
    jQuery('#tmenu-submenu-5 a:eq(3)').attr("aria-label","Brondell");
    jQuery('#tmenu-submenu-5 a:eq(4)').attr("aria-label","CleanSense");
    jQuery('#tmenu-submenu-5 a:eq(5)').attr("aria-label","TOTO");
    jQuery('#tmenu-submenu-5 a:eq(6)').attr("aria-label","Kohler");
    jQuery('#tmenu-submenu-5 a:eq(7)').attr("aria-label","Fluidmaster");
    jQuery('#tmenu-submenu-5 a:eq(8)').attr("aria-label","GoBidet");
    jQuery('#tmenu-submenu-5 a:eq(9)').attr("aria-label","Blooming");
    jQuery('#tmenu-submenu-5 a:eq(10)').attr("aria-label","Nova Bidet");

    jQuery('#tmenu-submenu-5 img:eq(0)').attr("alt","Alpha Bidet");
    jQuery('#tmenu-submenu-5 img:eq(1)').attr("alt","BidetKing");
    jQuery('#tmenu-submenu-5 img:eq(2)').attr("alt","Bio Bidet");
    jQuery('#tmenu-submenu-5 img:eq(3)').attr("alt","Brondell");
    jQuery('#tmenu-submenu-5 img:eq(4)').attr("alt","CleanSense");
    jQuery('#tmenu-submenu-5 img:eq(5)').attr("alt","TOTO");
    jQuery('#tmenu-submenu-5 img:eq(6)').attr("alt","Kohler");
    jQuery('#tmenu-submenu-5 img:eq(7)').attr("alt","Fluidmaster");
    jQuery('#tmenu-submenu-5 img:eq(8)').attr("alt","GoBidet");
    jQuery('#tmenu-submenu-5 img:eq(9)').attr("alt","Blooming");
    jQuery('#tmenu-submenu-5 img:eq(10)').attr("alt","Nova Bidet");

    // Wave error resolve start:
        jQuery('.easypopup-one-whole, .popup-widget-image img').attr("alt","");
        jQuery('.shg-image-content-wrapper a').attr("aria-label","Best Bidet Seat of 2026");
        jQuery('.shg-image-content-wrapper img').attr("alt","Best Bidet Seat of 2026");
        jQuery('.header__logo-link img').attr("alt","Bide King logo");
        jQuery('label.form__floating-label[for="newsletter[contact][email]"]').remove();
        jQuery('#block-image_zzgbxx img.slideshow__image').attr('alt', 'End of summer sale – up to 25% off sitewide. Shop bidet sale.');
    // Wave error resolve end:

    setTimeout(function(){ 
        jQuery('.iubenda_legal_document h1').attr("aria-level","2");
        jQuery('.iubenda_legal_document h1').attr("role","heading");
        jQuery('br').attr("aria-hidden","true");

        jQuery("p:contains('support@bidetking.com')").each(function () {

            var $p = jQuery(this);

            // Only process if the email is not already inside a link
            if (!$p.find("a[href^='mailto:support@bidetking.com']").length) {

                $p.html(function (_, html) {

                    return html.replace(
                        'support@bidetking.com',
                        '<a href="mailto:support@bidetking.com" aria-label="Email Bidet King Support at support@bidetking.com">support@bidetking.com</a>'
                    );

                });

            }

        });
         
     },
    2000);

    // ========================================= Product detial section  =================================================

        (function () {
        var SCOPE = '.card--sticky';
        var VAGUE = /^\(?\s*(click for details|details|click here|learn more|read more|more info|more)\s*\)?$/i;
        var uid = 0, busy = false;

        function run() {
            if (busy) return;
            busy = true;

            document.querySelectorAll(SCOPE).forEach(function (card) {

            // 1. give every variant option group an accessible name
            card.querySelectorAll('.product-form__option').forEach(function (opt) {
                var nameEl = opt.querySelector('.product-form__option-name');
                var list = opt.querySelector('.block-swatch-list, .color-swatch-list');
                if (!nameEl || !list) return;
                if (!nameEl.id) nameEl.id = 'a11y-opt-name-' + (++uid);
                if (list.getAttribute('role') !== 'radiogroup') list.setAttribute('role', 'radiogroup');
                if (list.getAttribute('aria-labelledby') !== nameEl.id) list.setAttribute('aria-labelledby', nameEl.id);
            });

            // 2. expose unavailable variants (strikethrough alone is a visual-only cue).
            //    aria-disabled, not disabled, so the option stays discoverable.
            card.querySelectorAll('.block-swatch, .color-swatch').forEach(function (sw) {
                var input = sw.querySelector('input[type="radio"]');
                var label = sw.querySelector('.block-swatch__item, .color-swatch__item');
                if (!input || !label) return;
                var off = /--disabled|is-disabled|unavailable|sold-out/.test(sw.className);
                if (off) {
                input.setAttribute('aria-disabled', 'true');
                input.setAttribute('data-a11y-unavail', '1');
                input.setAttribute('aria-label', (label.getAttribute('title') || label.textContent || '').trim() + ' (unavailable)');
                } else if (input.getAttribute('data-a11y-unavail') === '1') {
                input.removeAttribute('aria-disabled');
                input.removeAttribute('aria-label');
                input.removeAttribute('data-a11y-unavail');
                }
            });

            // 3. give non-descriptive links a purpose, and declare dialog triggers
            card.querySelectorAll('a[href], button').forEach(function (el) {
                var txt = (el.textContent || '').trim();
                var href = (el.getAttribute('href') || '').toLowerCase();
                var opensDialog = href.indexOf('popup') > -1;
                if (opensDialog) el.setAttribute('aria-haspopup', 'dialog');
                if (!VAGUE.test(txt)) return;
                if (el.getAttribute('aria-label') || el.getAttribute('aria-labelledby')) return;
                var ctx = '', n = el.parentElement;
                for (var i = 0; i < 3 && n && !ctx; i++, n = n.parentElement) {
                ctx = (n.textContent || '').replace(txt, '').replace(/\s+/g, ' ').trim();
                }
                if (!ctx) return;
                el.setAttribute('aria-label',
                ctx.slice(0, 90) + ' \u2014 ' + txt.replace(/[()]/g, '').trim() + (opensDialog ? ', opens a dialog' : ''));
            });

            // 4. expose the star rating value, not just "see all reviews"
            card.querySelectorAll('.jdgm-prev-badge').forEach(function (b) {
                var stars = b.querySelector('.jdgm-prev-badge__stars');
                var avg = b.getAttribute('data-average-rating');
                var count = b.getAttribute('data-number-of-reviews');
                if (!stars || !avg) return;
                stars.setAttribute('aria-label',
                'Rated ' + avg + ' out of 5 stars' + (count ? ' from ' + count + ' reviews' : '') + ' \u2014 see all reviews');
            });
            });

            busy = false;
        }

        function init() {
            run();
            document.querySelectorAll(SCOPE).forEach(function (card) {
            if (card.__buyBoxObs) return;
            card.__buyBoxObs = new MutationObserver(run);
            // the form rebuilds itself on every variant change
            card.__buyBoxObs.observe(card, {
                childList: true, subtree: true, attributes: true,
                attributeFilter: ['class', 'href', 'title', 'data-average-rating']
            });
            });
        }

        document.addEventListener('DOMContentLoaded', init);
        init();
        })();



    // ========================================= recently viewed product slider on product page =================================================

        // (function () {
        // var SCOPE = '.recently-viewed-products-placeholder';
        // var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),'
        //                 + 'textarea:not([disabled]),iframe,[tabindex]:not([tabindex="-1"])';
        // var busy = false;

        // function syncCell(cell) {
        //     var hidden = cell.getAttribute('aria-hidden') === 'true';
        //     cell.querySelectorAll(FOCUSABLE + ',[data-a11y-ti]').forEach(function (el) {
        //     if (hidden) {
        //         if (!el.hasAttribute('data-a11y-ti')) {
        //         el.setAttribute('data-a11y-ti', el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : '');
        //         el.setAttribute('tabindex', '-1');
        //         }
        //     } else if (el.hasAttribute('data-a11y-ti')) {
        //         var p = el.getAttribute('data-a11y-ti');
        //         if (p === '') el.removeAttribute('tabindex'); else el.setAttribute('tabindex', p);
        //         el.removeAttribute('data-a11y-ti');
        //     }
        //     });
        // }

        // function enhance(list) {
        //     if (list.__rvA11y) return;
        //     list.__rvA11y = true;

        //     var section = list.closest('.section') || list.closest('.shopify-section');
        //     var h = section && section.querySelector('h2, .section__title');
        //     var name = (h && h.textContent.trim()) || 'Recently viewed';

        //     function sync() {
        //     if (busy) return;
        //     busy = true;

        //     var carousel = list.classList.contains('flickity-enabled');
        //     list.setAttribute('role', 'group');
        //     list.setAttribute('aria-label', carousel
        //         ? name + ' \u2014 horizontal product slider, use left and right arrow keys to scroll'
        //         : name + ' \u2014 product list');

        //     var p = list.querySelector('.flickity-prev-next-button.previous');
        //     var n = list.querySelector('.flickity-prev-next-button.next');
        //     if (p) p.setAttribute('aria-label', 'Previous products in ' + name);
        //     if (n) n.setAttribute('aria-label', 'Next products in ' + name);

        //     list.querySelectorAll('.product-item').forEach(syncCell);

        //     // the browser will scroll this overflow:hidden box to reveal an off-screen
        //     // card, which desyncs Flickity's transform from what is on screen
        //     var vp = list.querySelector('.flickity-viewport');
        //     if (vp && !vp.__rvGuard) {
        //         vp.__rvGuard = true;
        //         vp.scrollLeft = 0;
        //         vp.addEventListener('scroll', function () { if (vp.scrollLeft !== 0) vp.scrollLeft = 0; });
        //     }

        //     busy = false;
        //     }

        //     sync();
        //     // attributes matter as well as childList: Judge.me upgrades its rating badge to
        //     // role="button" tabindex="0" after first paint, re-adding stops in hidden cells
        //     new MutationObserver(sync).observe(list, {
        //     childList: true, subtree: true, attributes: true,
        //     attributeFilter: ['class', 'tabindex', 'role', 'aria-hidden', 'href']
        //     });
        // }

        // function init() { document.querySelectorAll(SCOPE + ' .product-list--scrollable').forEach(enhance); }

        // document.addEventListener('DOMContentLoaded', init);
        // init();
        // // this section is assembled client-side from the visitor's history, so it can
        // // appear well after load
        // new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
        // })();



    // =========================================You may also like slider on product page =================================================

        (function () {
        var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),'
                        + 'textarea:not([disabled]),iframe,[tabindex]:not([tabindex="-1"])';

        function syncCell(cell) {
            var hidden = cell.getAttribute('aria-hidden') === 'true';
            cell.querySelectorAll(FOCUSABLE + ',[data-a11y-ti]').forEach(function (el) {
            if (hidden) {
                if (!el.hasAttribute('data-a11y-ti')) {
                el.setAttribute('data-a11y-ti', el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : '');
                el.setAttribute('tabindex', '-1');
                }
            } else if (el.hasAttribute('data-a11y-ti')) {
                var prev = el.getAttribute('data-a11y-ti');
                if (prev === '') el.removeAttribute('tabindex'); else el.setAttribute('tabindex', prev);
                el.removeAttribute('data-a11y-ti');
            }
            });
        }

        function enhance(list) {
            if (list.__prA11y) return;
            list.__prA11y = true;

            var section = list.closest('.section') || list.closest('.shopify-section');
            var h = section && section.querySelector('h2, .section__title');
            var name = (h && h.textContent.trim()) || 'Recommended products';

            function sync() {
            var carousel = list.classList.contains('flickity-enabled');
            list.setAttribute('role', 'group');
            list.setAttribute('aria-label', carousel
                ? name + ' \u2014 horizontal product slider, use left and right arrow keys to scroll'
                : name + ' \u2014 product list');

            var p = list.querySelector('.flickity-prev-next-button.previous');
            var n = list.querySelector('.flickity-prev-next-button.next');
            if (p) p.setAttribute('aria-label', 'Previous products in ' + name);
            if (n) n.setAttribute('aria-label', 'Next products in ' + name);

            list.querySelectorAll('.product-item').forEach(function (cell) {
                syncCell(cell);
                if (!cell.__prA11yObs) {
                cell.__prA11yObs = new MutationObserver(function () { syncCell(cell); });
                cell.__prA11yObs.observe(cell, { attributes: true, attributeFilter: ['aria-hidden'] });
                }
            });

            // stop the browser scrolling the overflow:hidden viewport, which desyncs Flickity
            var vp = list.querySelector('.flickity-viewport');
            if (vp && !vp.__prA11yGuard) {
                vp.__prA11yGuard = true;
                vp.scrollLeft = 0;
                vp.addEventListener('scroll', function () { if (vp.scrollLeft !== 0) vp.scrollLeft = 0; });
            }
            }

            sync();
            new MutationObserver(sync).observe(list, { attributes: true, attributeFilter: ['class'] });
        }

        function init() {
            document.querySelectorAll('.product-recommendations .product-list--scrollable').forEach(enhance);
        }

        document.addEventListener('DOMContentLoaded', init);
        init();
        // recommendations are fetched async and sections can re-render in the theme editor
        new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
        })();


    // ========================================= Popup up dialog on product page =================================================
        // (function(){
        // var FOCUSABLE='a[href],area[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),iframe,[tabindex]:not([tabindex="-1"]),[contenteditable="true"]';
        // var isTrigger=function(e){return e&&e.matches&&e.matches('a,button')&&/prop\w*\s*65/i.test(e.textContent||'')&&/^#/.test(e.getAttribute('href')||'#');};
        // function triggers(){return [].slice.call(document.querySelectorAll('a,button')).filter(isTrigger);}
        // var lastTrigger=null,current=null,inerted=[],uid=0;

        // function markTriggers(){triggers().forEach(function(t){
        // t.setAttribute('aria-haspopup','dialog');
        // if(!t.hasAttribute('aria-expanded'))t.setAttribute('aria-expanded','false');});}
        // markTriggers();

        // /* document-level capture, so no per-element bookkeeping is needed */
        // document.addEventListener('click',function(e){
        // var n=e.target; while(n&&n!==document.body){if(isTrigger(n)){lastTrigger=n;return;}n=n.parentElement;}
        // },true);

        // function inertOn(dialog){
        // inerted=[]; var node=dialog;
        // while(node&&node!==document.body&&node.parentElement){
        // var parent=node.parentElement,cur=node;
        // [].slice.call(parent.children).forEach(function(sib){
        //     if(sib===cur||/^(STYLE|SCRIPT|LINK)$/.test(sib.tagName))return;
        //     if(sib.inert)return;                 /* already inert elsewhere: don't claim it */
        //     try{sib.inert=true;inerted.push(sib);}catch(e){}
        // });
        // node=parent;
        // }
        // }
        // /* restore from the tracked list: the dialog node is gone by close time */
        // function inertOff(){inerted.forEach(function(e){try{e.inert=false;}catch(err){}});inerted=[];}

        // function focusablesIn(root){
        // return [].slice.call(root.querySelectorAll(FOCUSABLE)).filter(function(e){
        // return e.offsetParent!==null&&getComputedStyle(e).visibility!=='hidden';});
        // }

        // function enhance(fl){
        // if(fl.__p65done)return; fl.__p65done=true; current=fl;
        // fl.setAttribute('role','dialog');
        // fl.setAttribute('aria-modal','true');
        // fl.setAttribute('tabindex','-1');
        // if(!fl.id)fl.id='p65-dialog';

        // var head=[].slice.call(fl.querySelectorAll('p,strong,h1,h2,h3,h4')).filter(function(p){
        // return /prop\w*sition\s*65/i.test(p.textContent||'')&&p.offsetParent!==null;})[0];
        // if(head){
        // if(!head.id)head.id='p65-dialog-title-'+(++uid);
        // head.setAttribute('role','heading');head.setAttribute('aria-level','2');
        // fl.setAttribute('aria-labelledby',head.id);
        // }else fl.setAttribute('aria-label','Proposition 65 warning for California consumers');

        // [].slice.call(fl.querySelectorAll('img')).forEach(function(i){
        // if(!i.hasAttribute('alt'))i.setAttribute('alt','');
        // i.setAttribute('aria-hidden','true');});

        // [].slice.call(fl.querySelectorAll('.ep_featherlight-close,.ep_featherlight-close-icon')).forEach(function(c){
        // c.setAttribute('role','button');c.setAttribute('tabindex','0');
        // c.setAttribute('aria-label','Close Proposition 65 warning');
        // if(!c.__p65key){c.__p65key=true;c.addEventListener('keydown',function(e){
        //     if(e.key==='Enter'||e.key===' '||e.key==='Spacebar'){e.preventDefault();c.click();}});}
        // });

        // if(lastTrigger){lastTrigger.setAttribute('aria-expanded','true');lastTrigger.setAttribute('aria-controls',fl.id);}
        // inertOn(fl);
        // setTimeout(function(){try{fl.focus();}catch(e){}},0);
        // }

        // function closeCleanup(){
        // if(!current)return;
        // current=null;
        // inertOff();                            /* must precede the focus restore */
        // triggers().forEach(function(t){t.setAttribute('aria-expanded','false');t.removeAttribute('aria-controls');});
        // var t=lastTrigger; if(!t)return;
        // var tries=0;
        // (function restore(){try{t.focus();}catch(e){}
        // if(document.activeElement!==t&&tries++<8)setTimeout(restore,60);})();
        // }

        // document.addEventListener('keydown',function(e){
        // var fl=document.querySelector('.ep_featherlight'); if(!fl)return;
        // if(e.key==='Escape'){e.preventDefault();
        // var c=fl.querySelector('.ep_featherlight-close,.ep_featherlight-close-icon');
        // if(c)c.click(); else closeCleanup(); return;}
        // if(e.key!=='Tab')return;
        // var f=focusablesIn(fl);
        // if(!f.length){e.preventDefault();fl.focus();return;}
        // var first=f[0],last=f[f.length-1],a=document.activeElement;
        // if(e.shiftKey){if(a===first||a===fl||!fl.contains(a)){e.preventDefault();last.focus();}}
        // else{if(a===last||!fl.contains(a)){e.preventDefault();first.focus();}}
        // },true);

        // new MutationObserver(function(muts){
        // for(var i=0;i<muts.length;i++){var add=muts[i].addedNodes;
        // for(var j=0;j<add.length;j++){var n=add[j]; if(n.nodeType!==1)continue;
        //     var fl=(n.classList&&n.classList.contains('ep_featherlight'))?n:(n.querySelector&&n.querySelector('.ep_featherlight'));
        //     if(fl)enhance(fl);}}
        // if(current&&!document.querySelector('.ep_featherlight'))closeCleanup();
        // markTriggers();
        // }).observe(document.documentElement,{childList:true,subtree:true});
        // })();

        /* EasyPopup (ep_featherlight) dialogs — accessibility layer
                BidetKing product pages: #prop65, #quickshippopup, #shippingpolicypopup,
                #easyreturnsandexchangespopup, #30daytrialpopup — and any future popup.

                The previous version only recognised the "see Prop 65 WARNINGS" link, so every
                other popup closed with focus on <body> (or on the Prop 65 link). Triggers are
                now identified by behaviour — whatever was clicked immediately before a dialog
                appeared — and each dialog is named from its own content.
                */
            (function () {
                if (window.__epA11yInit) return;                 // never run twice
                window.__epA11yInit = true;

                var FOCUSABLE = 'a[href],area[href],button:not([disabled]),input:not([disabled]),' +
                    'select:not([disabled]),textarea:not([disabled]),iframe,[tabindex]:not([tabindex="-1"]),' +
                    '[contenteditable="true"]';

                var DIALOG    = '.ep_featherlight';
                var CLOSE     = '.ep_featherlight-close,.ep_featherlight-close-icon';
                var INERT_MARK = 'data-epa11y-inert';
                var TRIG_MARK  = 'data-epa11y-trigger';          // learned triggers survive re-renders

                var pendingTrigger = null, pendingAt = 0;        // last plausible opener click
                var opener = null;                               // trigger that opened the CURRENT dialog
                var openDialog = null;                           // set on open, cleared on close
                var uid = 0;

                /* ---------- trigger identification ---------- */

                // EasyPopup injects popup markup on demand, so a trigger's #target does not
                // exist in the document. That plus aria-haspopup covers the static case; any
                // trigger we actually observe opening a dialog is marked and trusted after.
                function looksLikeTrigger(el) {
                    if (!el || !el.matches) return false;
                    if (el.hasAttribute(TRIG_MARK)) return true;
                    if (!el.matches('a,button,[role="button"]')) return false;
                    var href = el.getAttribute('href');
                    if (el.getAttribute('aria-haspopup') === 'dialog') return true;
                    if (!href || href.charAt(0) !== '#' || href.length < 2) return false;
                    try { return !document.querySelector(href); } catch (e) { return false; }
                }

                function markTrigger(el) {
                    if (!el) return;
                    el.setAttribute(TRIG_MARK, '');
                    el.setAttribute('aria-haspopup', 'dialog');
                    if (!el.hasAttribute('aria-expanded')) el.setAttribute('aria-expanded', 'false');
                    // an <a> with no href is not focusable — focus() would silently do nothing
                    if (el.tagName === 'A' && !el.hasAttribute('href') && !el.hasAttribute('tabindex')) {
                    el.setAttribute('tabindex', '0');
                    el.setAttribute('role', 'button');
                    }
                }

                function markKnownTriggers() {
                    [].slice.call(document.querySelectorAll('a[href^="#"],button,[role="button"]'))
                    .forEach(function (el) { if (looksLikeTrigger(el)) markTrigger(el); });
                }

                document.addEventListener('click', function (e) {
                    var n = e.target;
                    while (n && n !== document.body) {
                    if (n.matches && n.matches('a,button,[role="button"]')) {
                        pendingTrigger = n; pendingAt = Date.now();  // candidate, confirmed on open
                        return;
                    }
                    n = n.parentElement;
                    }
                }, true);

                /* ---------- inert ---------- */

                function inertOn(dialog) {
                    inertOff();                                   // never stack two inert layers
                    var node = dialog;
                    while (node && node !== document.body && node.parentElement) {
                    var parent = node.parentElement, cur = node;
                    [].slice.call(parent.children).forEach(function (sib) {
                        if (sib === cur || /^(STYLE|SCRIPT|LINK)$/.test(sib.tagName)) return;
                        if (sib.inert && !sib.hasAttribute(INERT_MARK)) return;   // owned elsewhere
                        try { sib.inert = true; sib.setAttribute(INERT_MARK, ''); } catch (e) {}
                    });
                    node = parent;
                    }
                }

                // Idempotent and self-healing: clears anything we ever marked, including leftovers
                // from a run that died mid-flight. An orphaned inert ancestor makes the trigger
                // unfocusable and focus() fail with no error — the classic silent failure.
                function inertOff() {
                    [].slice.call(document.querySelectorAll('[' + INERT_MARK + ']')).forEach(function (el) {
                    try { el.inert = false; } catch (e) {}
                    el.removeAttribute(INERT_MARK);
                    });
                }

                function focusablesIn(root) {
                    return [].slice.call(root.querySelectorAll(FOCUSABLE)).filter(function (e) {
                    return e.offsetParent !== null && getComputedStyle(e).visibility !== 'hidden';
                    });
                }

                /* ---------- naming ---------- */

                function nameDialog(fl) {
                    // 1. a real heading in the popup content
                    var head = [].slice.call(fl.querySelectorAll('h1,h2,h3,h4,h5,h6'))
                    .filter(function (h) { return (h.textContent || '').trim() && h.offsetParent !== null; })[0];

                    // 2. otherwise a short <strong>/<p> acting as a visual title (the Prop 65 case)
                    if (!head) {
                    head = [].slice.call(fl.querySelectorAll('strong,p')).filter(function (p) {
                        var t = (p.textContent || '').trim();
                        return t && t.length < 120 && p.offsetParent !== null;
                    })[0];
                    if (head) { head.setAttribute('role', 'heading'); head.setAttribute('aria-level', '2'); }
                    }

                    if (head) {
                    if (!head.id) head.id = 'ep-dialog-title-' + (++uid);
                    fl.setAttribute('aria-labelledby', head.id);
                    fl.removeAttribute('aria-label');
                    return (head.textContent || '').trim();
                    }

                    // 3. last resort: name it from the trigger, never from a hardcoded topic
                    var fallback = opener ? (opener.getAttribute('aria-label') ||
                    (opener.closest('.quickbullet,.shipbullet,li,p,div') || opener).textContent || '') : '';
                    fallback = fallback.trim().replace(/\s+/g, ' ').replace(/\(?click (here )?for details\)?/i, '').trim();
                    fl.setAttribute('aria-label', fallback || 'Dialog');
                    return fallback || 'Dialog';
                }

                /* ---------- open ---------- */

                function enhance(fl) {
                    // Confirm the opener BEFORE the decorate-once guard, so state is correct on
                    // every open even when the dialog node is reused or a second copy of this
                    // script decorated it first.
                    opener = (Date.now() - pendingAt < 2000 && pendingTrigger &&
                            document.body.contains(pendingTrigger)) ? pendingTrigger : null;
                    if (opener) markTrigger(opener);

                    openDialog = fl;
                    if (!fl.id) fl.id = 'ep-dialog-' + (++uid);
                    if (opener) {
                    opener.setAttribute('aria-expanded', 'true');
                    opener.setAttribute('aria-controls', fl.id);
                    }
                    inertOn(fl);
                    requestAnimationFrame(function () { try { fl.focus({ preventScroll: true }); } catch (e) {} });

                    if (fl.__epA11yDone) return;
                    fl.__epA11yDone = true;

                    fl.setAttribute('role', 'dialog');
                    fl.setAttribute('aria-modal', 'true');
                    fl.setAttribute('tabindex', '-1');

                    var title = nameDialog(fl);

                    [].slice.call(fl.querySelectorAll('img')).forEach(function (i) {
                    if (!i.hasAttribute('alt')) i.setAttribute('alt', '');
                    if (!(i.getAttribute('alt') || '').trim()) i.setAttribute('aria-hidden', 'true');
                    });

                    [].slice.call(fl.querySelectorAll(CLOSE)).forEach(function (c) {
                    c.setAttribute('role', 'button');
                    c.setAttribute('tabindex', '0');
                    c.setAttribute('aria-label', title && title !== 'Dialog' ? 'Close ' + title : 'Close dialog');
                    if (!c.__epA11yKey) {
                        c.__epA11yKey = true;
                        c.addEventListener('keydown', function (e) {
                        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                            e.preventDefault(); c.click();
                        }
                        });
                    }
                    });
                }

                /* ---------- close ---------- */

                function closeCleanup() {
                    if (!openDialog) return;
                    openDialog = null;

                    inertOff();                                   // must precede the focus restore

                    var t = opener;
                    // if the opener was re-rendered away, fall back to the same href in the live DOM
                    if (t && !document.body.contains(t)) {
                    var href = t.getAttribute('href');
                    t = (href && document.querySelector('a[href="' + href + '"]')) || null;
                    }
                    opener = null;

                    [].slice.call(document.querySelectorAll('[' + TRIG_MARK + ']')).forEach(function (el) {
                    el.setAttribute('aria-expanded', 'false');
                    el.removeAttribute('aria-controls');
                    });

                    if (!t) return;
                    var tries = 0;
                    (function restore() {
                    try { t.focus({ preventScroll: true }); } catch (e) {}
                    if (document.activeElement === t) return;
                    if (tries++ < 12) { setTimeout(restore, 50); return; }
                    try {                                        // last resort, rather than dropping to <body>
                        if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
                        t.focus({ preventScroll: true });
                    } catch (e) {}
                    })();
                }

                /* ---------- keyboard ---------- */

                document.addEventListener('keydown', function (e) {
                    var fl = document.querySelector(DIALOG);
                    if (!fl) return;

                    if (e.key === 'Escape') {
                    e.preventDefault();
                    var c = fl.querySelector(CLOSE);
                    if (c) c.click(); else closeCleanup();
                    return;
                    }
                    if (e.key !== 'Tab') return;

                    var f = focusablesIn(fl);
                    if (!f.length) { e.preventDefault(); fl.focus({ preventScroll: true }); return; }
                    var first = f[0], last = f[f.length - 1], a = document.activeElement;
                    if (e.shiftKey) {
                    if (a === first || a === fl || !fl.contains(a)) { e.preventDefault(); last.focus(); }
                    } else {
                    if (a === last || !fl.contains(a)) { e.preventDefault(); first.focus(); }
                    }
                }, true);

                /* ---------- observer ---------- */

                markKnownTriggers();

                function isVisible(el) {
                    if (!el || !document.body.contains(el)) return false;
                    var s = getComputedStyle(el);
                    return s.display !== 'none' && s.visibility !== 'hidden';
                }

                new MutationObserver(function (muts) {
                    for (var i = 0; i < muts.length; i++) {
                    var add = muts[i].addedNodes;
                    for (var j = 0; j < add.length; j++) {
                        var n = add[j];
                        if (n.nodeType !== 1) continue;
                        var fl = (n.classList && n.classList.contains('ep_featherlight'))
                        ? n : (n.querySelector && n.querySelector(DIALOG));
                        if (fl) enhance(fl);
                    }
                    }
                    // "hidden" counts as closed, not only "removed" — some builds just set display:none
                    if (openDialog && !isVisible(document.querySelector(DIALOG))) closeCleanup();
                    markKnownTriggers();
                }).observe(document.documentElement, {
                    childList: true, subtree: true,
                    attributes: true, attributeFilter: ['style', 'class']
                });
            })();



    // ========================================= Product sliders =================================================

        (function(){
        var SEL='.scroller.scroller--flush .product-list--scrollable';
        var FOCUSABLE='a[href],button,input,select,textarea,iframe,[tabindex]';
        function syncCell(cell){
        var hidden=cell.getAttribute('aria-hidden')==='true';
        [].slice.call(cell.querySelectorAll(FOCUSABLE)).forEach(function(el){
        if(hidden){
            if(!el.hasAttribute('data-a11y-ti'))el.setAttribute('data-a11y-ti',el.hasAttribute('tabindex')?el.getAttribute('tabindex'):'');
            el.setAttribute('tabindex','-1');
        }else if(el.hasAttribute('data-a11y-ti')){
            var v=el.getAttribute('data-a11y-ti');
            v===''?el.removeAttribute('tabindex'):el.setAttribute('tabindex',v);
            el.removeAttribute('data-a11y-ti');
        }
        });
        }
        function enhance(pl){
        if(pl.hasAttribute('data-a11y-done'))return; pl.setAttribute('data-a11y-done','1');
        var sec=pl.closest('.shopify-section');
        var name=((sec&&sec.querySelector('h1,h2,h3')||{}).textContent||'This collection').trim().replace(/\s+/g,' ');
        pl.setAttribute('role','group');
        pl.setAttribute('aria-label',name+' products \u2014 horizontal slider, use left and right arrow keys to scroll');
        var prev=pl.querySelector('.flickity-prev-next-button.previous');
        var next=pl.querySelector('.flickity-prev-next-button.next');
        if(prev)prev.setAttribute('aria-label','Previous products in '+name);
        if(next)next.setAttribute('aria-label','Next products in '+name);
        var slider=pl.querySelector('.flickity-slider'); if(!slider)return;
        [].slice.call(slider.children).forEach(function(c){
        syncCell(c);
        new MutationObserver(function(){syncCell(c)}).observe(c,{attributes:true,attributeFilter:['aria-hidden']});
        });
        }
        function run(){[].slice.call(document.querySelectorAll(SEL)).forEach(enhance)}
        if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
        window.addEventListener('load',run);
        setTimeout(run,1500);
        })();

    // ========================================= The autoplay GIF in the “Custom Bidet Toilet Combination” section is not accessible. =================================================
            (function(){
                    function enhance(img){
                var box=img.parentElement; if(!box||box.classList.contains('a11y-gif-box'))return;
                box.classList.add('a11y-gif-box');
                if(!img.id)img.id='a11y-gif-'+Math.random().toString(36).slice(2,8);
                var cv=document.createElement('canvas');cv.className='a11y-gif__still';cv.setAttribute('aria-hidden','true');box.appendChild(cv);
                var bar=document.createElement('div');bar.className='a11y-gif__bar';
                var btn=document.createElement('button');btn.type='button';btn.className='a11y-gif__btn';btn.setAttribute('aria-controls',img.id);
                var lab=document.createElement('span');lab.className='a11y-gif__label';
                btn.appendChild(lab);bar.appendChild(btn);box.appendChild(bar);
                function freeze(){var w=img.naturalWidth||img.clientWidth,h=img.naturalHeight||img.clientHeight;
                cv.width=w;cv.height=h;try{cv.getContext('2d').drawImage(img,0,0,w,h);return true}catch(e){return false}}
                function sync(){var p=box.classList.contains('is-paused');
                lab.textContent=p?'Play animation':'Pause animation';btn.setAttribute('aria-label',lab.textContent)}
                btn.addEventListener('click',function(){
                if(box.classList.contains('is-paused')){box.classList.remove('is-paused')}
                else{freeze();box.classList.add('is-paused')}
                sync()});
                sync();
                if(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches){
                var go=function(){if(freeze()){box.classList.add('is-paused');sync()}};
                img.complete?go():img.addEventListener('load',go,{once:true});
                }
                }
                function run(){
                [].slice.call(document.querySelectorAll('img')).forEach(function(i){
                if(/\.gif(\?|$)/i.test(i.currentSrc||i.src||''))enhance(i);
                });
                }
                if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
                window.addEventListener('load',run);
        })();

    // ========================================= The product specification table does not include a caption that identifies the purpose of the table. =================================================

        jQuery(function($){
            $('table').each(function(){
                var $table=$(this);

                if($table.find('caption').length){
                    return;
                }

                var $strong=$table.closest('.table-wrapper').prev('p').find('strong').first();

                if($strong.length&&$strong.text().toLowerCase().includes('specification')){
                    $table.prepend('<caption> Product'+ $strong.text().trim()+'</caption>');
                }
            });
        });

    // ========================================= Product prices in the cart drawer are missing descriptive labels such as Regular Price, Sale Price, and Unit Price. =================================================

            jQuery(function($){
                $('.mini-cart__price-list').each(function(){
                    var $priceList=$(this);

                    var $sale=$priceList.find('.price--highlight');
                    if($sale.find('.visually-hidden').length===0){
                        $sale.prepend('<span class="visually-hidden">Sale price </span>');
                    }

                    var $regular=$priceList.find('.price--compare');
                    if($regular.find('.visually-hidden').length===0){
                        $regular.prepend('<span class="visually-hidden">Regular price </span>');
                    }

                    var $unit=$priceList.find('.price--unit');
                    if($unit.length&&$unit.find('.visually-hidden').length===0){
                        $unit.prepend('<span class="visually-hidden">Unit price </span>');
                    }
                });
        });
    
    // ========================================= Accessible Dialog boxes SHIPPING POLICY and EASY RETURNS AND EXCHANGES =================================================

            jQuery(function($){
            var lastFocus;

            $('a[href="#easyreturnsandexchangespopup"],a[href="#shippingpolicypopup"]').on('click',function(){
                lastFocus=this;

                setTimeout(function(){
                    var $dialog=$('.ep_featherlight:visible');
                    if(!$dialog.length)return;

                    var $content=$dialog.find('.ep_featherlight-content');
                    var $close=$dialog.find('.ep_featherlight-close');

                    var titleId='popup-title-'+Date.now();
                    var $title=$content.find('h1').first();

                    if($title.length){
                        $title.attr('id',titleId);
                        $dialog.attr({
                            role:'dialog',
                            'aria-modal':'true',
                            'aria-labelledby':titleId
                        });
                    }else{
                        $dialog.attr({
                            role:'dialog',
                            'aria-modal':'true',
                            'aria-label':'Popup dialog'
                        });
                    }

                    $close.attr({
                        role:'button',
                        tabindex:'0',
                        'aria-label':'Close dialog'
                    });

                    function getFocusable(){
                        return $dialog.find('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])')
                            .filter(':visible:not([disabled])');
                    }

                    $close.focus();

                    $(document).off('keydown.popup').on('keydown.popup',function(e){
                        if(!$dialog.is(':visible'))return;

                        if(e.key==='Escape'){
                            e.preventDefault();
                            $close.trigger('click');
                            return;
                        }

                        if(e.key!=='Tab')return;

                        var $focusable=getFocusable();
                        var first=$focusable.first()[0];
                        var last=$focusable.last()[0];

                        if(e.shiftKey){
                            if(document.activeElement===first){
                                e.preventDefault();
                                last.focus();
                            }
                        }else{
                            if(document.activeElement===last){
                                e.preventDefault();
                                first.focus();
                            }
                        }
                    });

                    $close.off('keydown.popup').on('keydown.popup',function(e){
                        if(e.key==='Enter'||e.key===' '){
                            e.preventDefault();
                            $(this).trigger('click');
                        }
                    });

                    $close.off('click.popup').on('click.popup',function(){
                        $(document).off('keydown.popup');
                        if(lastFocus)$(lastFocus).focus();
                    });
                },300);
            });
            });

    // ========================================= add descriptive labesl =================================================

        jQuery(function($){
            $('a[href="#shippingpolicypopup"]').attr({
                'aria-label':'View shipping policy details, opens a dialog',
                'aria-haspopup':'dialog'
                });
        });

        jQuery(function($){
            $('a[href="#easyreturnsandexchangespopup"]').attr({
                'aria-label':'View easy returns and exchanges policy, opens a dialog',
                'aria-haspopup':'dialog'
                });
        });

    
    // ========================================= FAQ headings adjustment =================================================

        jQuery(function($){
            $('.faq__group-title.heading.h2').each(function(){
                $(this).replaceWith(function(){
                    return $('<h2>',{
                        class:this.className,
                        html:this.innerHTML
                    });
                });
            });
        });

        jQuery(function($){
            $('.text-with-icons.text-with-icons--boxed .text-with-icons__title.text--strong').each(function(){
                if(this.tagName.toLowerCase()==='p'){
                    $(this).replaceWith(function(){
                        return $('<h3>',{
                            class:this.className,
                            html:this.innerHTML
                        });
                    });
                }
            });
        });

        jQuery(function($){
            $('.shopify-section.shopify-section-group-footer-group .text-with-icons__title.text--strong').each(function(){
                if(this.tagName.toLowerCase()==='p'){
                    $(this).replaceWith(function(){
                        return $('<h2>',{
                            class:this.className,
                            html:this.innerHTML
                        });
                    });
                }
            });
        });
    // ========================================= Accordion hidden content is announced by screen readers when collapsed. =================================================

        jQuery(function($){
            function updateAccordion(){
                $('.faq__question').each(function(){
                    var expanded=$(this).attr('aria-expanded')==='true';
                    var $panel=$('#'+$(this).attr('aria-controls'));

                    $panel.attr({
                        role:'region',
                        'aria-labelledby':$(this).attr('id')
                    });

                    if(expanded){
                        $panel.removeAttr('aria-hidden');
                        $panel.find('a,button,input,select,textarea,[tabindex]').removeAttr('tabindex');
                    }else{
                        $panel.attr('aria-hidden','true');
                        $panel.find('a,button,input,select,textarea,[tabindex]').attr('tabindex','-1');
                    }
                });
            }

            $('.faq__question').each(function(i){
                if(!$(this).attr('id')){
                    $(this).attr('id','faq-question-'+i);
                }
            });

            updateAccordion();

            $(document).on('click','.faq__question',function(){
                setTimeout(updateAccordion,50);
            });

            new MutationObserver(updateAccordion).observe(document.body,{
                subtree:true,
                attributes:true,
                attributeFilter:['aria-expanded','style','class']
            });
        });

    // ========================================= Error suggestion updated for review input fields =================================================

        jQuery(function($){
            function updateErrors(){
                $('.jdgm-form__fieldset').each(function(){
                    var $field=$(this).find('input,textarea,select').first();
                    var $label=$(this).find('label[for="'+$field.attr('id')+'"]').first();
                    var $error=$(this).find('[id$="-error"],.jdgm-input-error').last();

                    if(!$field.length||!$label.length||!$error.length){
                        return;
                    }

                    var label=$.trim($label.text()).replace(/\*$/,'');
                    var message=$.trim($error.text());

                    if(message&&!message.startsWith(label+':')){
                        $error.text(label+': '+message);
                    }

                    if(!$error.attr('id')){
                        $error.attr('id',$field.attr('id')+'-error');
                    }

                    $field.attr({
                        'aria-describedby':$error.attr('id'),
                        'aria-invalid':'true'
                    });
                });
            }

            updateErrors();

            new MutationObserver(updateErrors).observe(document.body,{
                childList:true,
                subtree:true,
                characterData:true
            });
        });
    // ========================================= Customer review section tabs and review dates are not fully accessible. =================================================
        // jQuery(function($){
        //     var $tabs=$('.jdgm-subtab__name');

        //     $('.jdgm-subtab').attr({
        //         role:'tablist',
        //         'aria-label':'Product reviews'
        //     });

        //     $tabs.each(function(i){
        //         var name=$(this).data('tabname');

        //         $(this).attr({
        //             id:'jdgm-tab-'+name,
        //             role:'tab',
        //             'aria-selected':$(this).hasClass('jdgm--active'),
        //             tabindex:$(this).hasClass('jdgm--active')?'0':'-1'
        //         });
        //     });

        //     function activateTab($tab){
        //         $tabs.removeClass('jdgm--active').attr({
        //             'aria-selected':'false',
        //             tabindex:'-1'
        //         });

        //         $tab.addClass('jdgm--active').attr({
        //             'aria-selected':'true',
        //             tabindex:'0'
        //         }).focus();

        //         $tab.trigger('click');
        //     }

        //     $tabs.on('keydown',function(e){
        //         var index=$tabs.index(this);

        //         switch(e.key){
        //             case 'ArrowRight':
        //             case 'Right':
        //                 e.preventDefault();
        //                 activateTab($tabs.eq((index+1)%$tabs.length));
        //                 break;

        //             case 'ArrowLeft':
        //             case 'Left':
        //                 e.preventDefault();
        //                 activateTab($tabs.eq((index-1+$tabs.length)%$tabs.length));
        //                 break;

        //             case 'Home':
        //                 e.preventDefault();
        //                 activateTab($tabs.first());
        //                 break;

        //             case 'End':
        //                 e.preventDefault();
        //                 activateTab($tabs.last());
        //                 break;

        //             case ' ':
        //             case 'Enter':
        //                 e.preventDefault();
        //                 activateTab($(this));
        //                 break;
        //         }
        //     });

        //     $tabs.on('click',function(){
        //         activateTab($(this));
        //     });
        // });

        jQuery(function($){
            setTimeout(function(){

                var $tabs=$('.jdgm-subtab__name');

                $('.jdgm-subtab').attr({
                    role:'tablist',
                    'aria-label':'Product reviews'
                });

                $tabs.each(function(){
                    var name=$(this).data('tabname');

                    $(this).attr({
                        id:'jdgm-tab-'+name,
                        role:'tab',
                        'aria-selected':$(this).hasClass('jdgm--active'),
                        tabindex:$(this).hasClass('jdgm--active')?'0':'-1'
                    });
                });

                function activateTab($tab){
                    $tabs.removeClass('jdgm--active').attr({
                        'aria-selected':'false',
                        tabindex:'-1'
                    });

                    $tab.addClass('jdgm--active').attr({
                        'aria-selected':'true',
                        tabindex:'0'
                    }).focus();

                    $tab.trigger('click');
                }

                $tabs.on('keydown',function(e){
                    var index=$tabs.index(this);

                    switch(e.key){
                        case 'ArrowRight':
                        case 'Right':
                            e.preventDefault();
                            activateTab($tabs.eq((index+1)%$tabs.length));
                            break;

                        case 'ArrowLeft':
                        case 'Left':
                            e.preventDefault();
                            activateTab($tabs.eq((index-1+$tabs.length)%$tabs.length));
                            break;

                        case 'Home':
                            e.preventDefault();
                            activateTab($tabs.first());
                            break;

                        case 'End':
                            e.preventDefault();
                            activateTab($tabs.last());
                            break;

                        case ' ':
                        case 'Enter':
                            e.preventDefault();
                            activateTab($(this));
                            break;
                    }
                });

                $tabs.on('click',function(){
                    activateTab($(this));
                });

            },3000);
        });
    // ========================================= All pdfs external warnings =================================================

        jQuery(function($){
            $('a[href*=".pdf"]').each(function(){
                var text=$.trim($(this).text());
                $(this).attr('aria-label',text+' (PDF, opens in a new tab)');
            });
        });
    // ========================================= The “Learn more HSA/FSA eligible” popup is not fully accessible. =================================================
   
        jQuery(function($){
            var $dialog=$('truemed-instructions-modal');
            var lastFocused=null;

            $dialog.attr({
                role:'dialog',
                'aria-modal':'true',
                'aria-labelledby':'truemed-dialog-title',
                'aria-hidden':'true'
            });

            $('.truemed-instructions-header-title').attr('id','truemed-dialog-title');

            function getFocusable(){
                return $dialog.find('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])')
                    .filter(':visible:not([disabled])');
            }

            function openDialog(){
                lastFocused=document.activeElement;

                $dialog.attr('aria-hidden','false');

                var $focusable=getFocusable();
                if($focusable.length){
                    $focusable.first().focus();
                }
            }

            function closeDialog(){
                $dialog.attr('aria-hidden','true');

                $(document).off('keydown.truemed');

                if(lastFocused){
                    $(lastFocused).focus();
                }
            }

            function updateState(){
                if($dialog.is(':visible')){
                    if($dialog.attr('aria-hidden')==='true'){
                        openDialog();
                    }
                }else{
                    if($dialog.attr('aria-hidden')==='false'){
                        closeDialog();
                    }
                }
            }

            new MutationObserver(updateState).observe($dialog[0],{
                attributes:true,
                attributeFilter:['style','class']
            });

            $(document).on('keydown.truemed',function(e){
                if($dialog.attr('aria-hidden')==='true') return;

                var $focusable=getFocusable();
                if(!$focusable.length) return;

                if(e.key==='Escape'){
                    e.preventDefault();
                    $('.truemed-instructions-close-button').trigger('click');
                    return;
                }

                if(e.key!=='Tab') return;

                var first=$focusable.first()[0];
                var last=$focusable.last()[0];

                if(e.shiftKey){
                    if(document.activeElement===first){
                        e.preventDefault();
                        last.focus();
                    }
                }else{
                    if(document.activeElement===last){
                        e.preventDefault();
                        first.focus();
                    }
                }
            });

            $('.truemed-instructions-close-button').on('click',function(){
                setTimeout(closeDialog,0);
            });

            updateState();
        });

    // ========================================= Pagination navigation is missing a clear accessible label. =================================================

        jQuery(function($){
            $('.pagination').attr({
                'role':'navigation',
                'aria-label':'Pagination navigation'
            });

            $('.pagination__nav-item.is-active').attr({
                'aria-current':'page',
                'aria-label':'Current page, page '+$.trim($('.pagination__nav-item.is-active').text())
            });

            $('.pagination__nav-item.link').each(function(){
                var page=$.trim($(this).text());
                $(this).attr('aria-label','Go to page '+page);
            });

            $('.pagination__next').attr('aria-label','Go to next page');
        });


    // ========================================= Multiple “Choose Option” links are missing unique accessible names. =================================================

        jQuery(function($){
            $('.product-item').each(function(){
                var productName=$.trim($(this).find('.product-item__title').text());
                $(this).find('.product-item__action-button').filter(function(){
                    return $.trim($(this).text())==='Choose options';
                }).attr('aria-label','Choose options for '+productName);
            });
        });

    // ========================================= payment icons wraps inside list =================================================

        jQuery(function($){
            var $items=$('.payment-list').children('.payment-list__item');
            if($items.length&&!$('.payment-list').children('ul').length){
                $items.wrap('<li></li>');
                $('.payment-list').wrapInner('<ul class="payment-list__list"></ul>');
            }
        });


    // ========================================= Social media links in the footer are missing external link warning text. =================================================

        // jQuery(function($){
        //     $('.social-media__item a[target="_blank"]').each(function(){
        //         var label=$(this).attr('aria-label');
        //         if(label){
        //             $(this).attr('aria-label',label+' (opens in a new window)');
        //         }
        //     });
        // });


    // ========================================= The Add to Cart button does not indicate that it opens a dialog. =================================================

        jQuery(function ($) {

            var $cart = $('#mini-cart');
            var $trigger = $('[href="/cart"], .header__cart-toggle, [data-action="toggle-mini-cart"]').first();
            var lastFocused = null;
            var previousCount = parseInt($('.header__cart-count').first().text(), 10) || 0;

            if ($cart.length) {
                $cart.attr({
                    'role': 'dialog',
                    'aria-modal': 'true',
                    'aria-label': 'Shopping cart'
                });
            }

            if (!$('#cart-live-region').length) {
                $('body').append(
                    '<div id="cart-live-region" class="visually-hidden" aria-live="polite" aria-atomic="true"></div>'
                );
            }

            function trapFocus() {

                if ($cart.attr('aria-hidden') === 'true') return;

                var $focusable = $cart.find('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])')
                    .filter(':visible:not([disabled])');

                if (!$focusable.length) return;

                $focusable.first().focus();

                $(document).off('keydown.cartTrap').on('keydown.cartTrap', function (e) {

                    if (e.key === 'Escape') {
                        closeCart();
                        return;
                    }

                    if (e.key !== 'Tab') return;

                    var first = $focusable.first()[0];
                    var last = $focusable.last()[0];

                    if (e.shiftKey) {

                        if (document.activeElement === first) {
                            e.preventDefault();
                            last.focus();
                        }

                    } else {

                        if (document.activeElement === last) {
                            e.preventDefault();
                            first.focus();
                        }

                    }

                });

            }

            function closeCart() {

                $(document).off('keydown.cartTrap');

                if (lastFocused) {
                    $(lastFocused).focus();
                }

            }

            if ($trigger.length) {

                $trigger.attr('aria-haspopup', 'dialog');

                $trigger.on('click', function () {
                    lastFocused = this;

                    setTimeout(function () {
                        if ($cart.attr('aria-hidden') !== 'true') {
                            trapFocus();
                        }
                    }, 300);
                });

            }

            function announceCartChange() {

                var currentCount = parseInt($('.header__cart-count').first().text(), 10) || 0;

                if (currentCount === previousCount) return;

                var message = '';

                if (currentCount > previousCount) {

                    var itemName = $.trim(
                        $('.mini-cart .line-item:first .line-item__title, .mini-cart .cart-item:first .cart-item__title').first().text()
                    );

                    message = itemName
                        ? itemName + ' added to cart.'
                        : 'Item added to cart.';

                } else {

                    message = 'Item removed from cart.';

                }

                $('#cart-live-region').text('');

                setTimeout(function () {
                    $('#cart-live-region').text(message);
                }, 50);

                previousCount = currentCount;
            }

            new MutationObserver(announceCartChange).observe(
                $('.header__cart-count')[0],
                {
                    childList: true,
                    characterData: true,
                    subtree: true
                }
            );

        });

    
        // ========================================= Gallery thumbnails do not describe their function. =================================================

        jQuery(function($){

            $('.product-gallery__thumbnail').each(function(index){

                var $thumb = $(this);
                var alt = $.trim($thumb.find('img').attr('alt'));

                if ($thumb.find('.product-gallery__thumbnail-badge').length) {
                    $thumb.attr(
                        'aria-label',
                        'Load video in gallery view'
                    );
                } else {
                    $thumb.attr(
                        'aria-label',
                        'Load image ' + (index + 1) + ' in gallery view' + (alt ? ': ' + alt : '')
                    );
                }

                });

            });
    
    // ========================================= Multiple “Learn more” and view all links have the same accessible name. =================================================

        jQuery(function($){

            $('a.section__action-link').each(function(){

                var $link = $(this);
                var text = $.trim($link.text()).toUpperCase();

                var heading = $.trim(
                    $link.closest('section, .section, .container')
                        .find('h1, h2, h3, h4')
                        .first()
                        .text()
                );

                if(!heading) return;

                if(text.indexOf('LEARN MORE') > -1){
                    $link.attr('aria-label','Learn more about ' + heading);
                }

                if(text.indexOf('VIEW ALL') > -1){
                    $link.attr('aria-label','View all ' + heading);
                }

            });

        });

    // ========================================= Multiple “Learn more” links have the same accessible name. =================================================

    jQuery(function($){

        $('a:has(.promo-block__cta)').each(function(){

            var $link = $(this);

            var heading = $.trim(
                $link.find('.promo-block__heading').text()
            );

            if(heading){
                $link.attr('aria-label','Learn more about ' + heading);
            }

        });

        });
    // ========================================= Multiple “Shop Now” links have the same accessible name.=================================================

        jQuery(function($){

            $('a:contains("Shop Now")').each(function(){

                var $link = $(this);
                var href = $link.attr('href') || '';

                var collection = href.split('/').pop().replace(/-/g,' ');

                collection = collection.replace(/\b\w/g,function(letter){
                    return letter.toUpperCase();
                });

                $link.attr('aria-label','Shop now from the ' + collection + ' collection');

            });

        });
    // ========================================= Review slider navigation buttons are missing accessible labels..=================================================

        $('.jdgm-carousel__left-arrow')
            .attr({
                'role': 'button',
                'aria-label': 'Previous review slide'
            });

        $('.jdgm-carousel__right-arrow')
            .attr({
                'role': 'button',
                'aria-label': 'Next review slide'
            });
    
    // ========================================= Featured publication logos are missing alt attributes.=================================================

        jQuery(function ($) {

            $('.logo-bar__image').each(function () {

                var src = $(this).attr('src') || '';

                if (src.indexOf('usa_today') > -1) {
                    $(this).attr('alt', 'USA TODAY');
                } else if (src.indexOf('cnn_underscored') > -1) {
                    $(this).attr('alt', 'CNN Underscored');
                } else if (src.indexOf('fox_news') > -1) {
                    $(this).attr('alt', 'Fox News');
                } else if (src.indexOf('the_washington_post') > -1) {
                    $(this).attr('alt', 'The Washington Post');
                } else if (src.indexOf('Forbs') > -1) {
                    $(this).attr('alt', 'Forbes');
                } else if (src.indexOf('cnet') > -1) {
                    $(this).attr('alt', 'CNET');
                } else if (src.indexOf('vice') > -1) {
                    $(this).attr('alt', 'VICE');
                } else if (src.indexOf('allure') > -1) {
                    $(this).attr('alt', 'Allure');
                }

            });

        });

    // ========================================= The VIP Bidet Club popup form does not manage keyboard focus correctly when opened.=================================================   


        // jQuery(function($){

        // var $popup = $('#announcement-bar-newsletter');
        // var $trigger = $('[data-action="toggle-newsletter"]');
        // var $openButton = $('.announcement-bar__button');

        // function isOpen(){
        //     return $popup.css('height') !== '0px' && $popup.attr('aria-hidden') === 'false';
        // }

        // function trapFocus(e){

        //     if(!isOpen()) return;

        //     if(e.key !== 'Tab') return;

        //     var $focusable = $popup.find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])')
        //         .filter(':visible');

        //     if(!$focusable.length) return;

        //     var first = $focusable.first()[0];
        //     var last = $focusable.last()[0];

        //     if(e.shiftKey){
        //         if(document.activeElement === first){
        //             e.preventDefault();
        //             last.focus();
        //         }
        //     }else{
        //         if(document.activeElement === last){
        //             e.preventDefault();
        //             first.focus();
        //         }
        //     }
        // }

        // function updatePopup(){

        //     if(isOpen()){

        //         $trigger.attr('aria-expanded','true');

        //         if(document.activeElement !== $popup.find('input[type="email"]')[0]){
        //             setTimeout(function(){
        //                 $popup.find('input[type="email"]').trigger('focus');
        //             },100);
        //         }

        //     }else{

        //         $trigger.attr('aria-expanded','false');

        //         // "data-action=toggle-newsletter" also matches the close button inside the
        //         // panel, so lastFocused (captured on open) is not a reliable target here -
        //         // always send focus back to the actual opener button.
        //         $openButton.trigger('focus');
        //     }
        // }

        // new MutationObserver(updatePopup).observe($popup[0],{
        //     attributes:true,
        //     attributeFilter:['style','aria-hidden']
        // });

        // $(document).on('keydown',trapFocus);

        // // Closing (Escape via the theme's own toggle, or the close button) is handled natively
        // // by SlideshowAnnouncementBar's _toggleNewsletter(); updatePopup() above restores focus
        // // to lastFocused whenever aria-hidden/height report closed, whatever closed it.

        // updatePopup();

        // });

        // jQuery(function($){

        //             var $popup = $('#announcement-bar-newsletter');
        //             var $trigger = $('[data-action="toggle-newsletter"]');
        //             var $openButton = $('.announcement-bar__button');

        //             function isOpen(){

        //                 return $popup.length &&
        //                     $popup.css('height') !== '0px' &&
        //                     $popup.attr('aria-hidden') === 'false';

        //             }

        //             function trapFocus(e){

        //                 if(!isOpen()) return;

        //                 if(e.key !== 'Tab') return;

        //                 var $focusable = $popup
        //                     .find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])')
        //                     .filter(':visible');

        //                 if(!$focusable.length) return;

        //                 var first = $focusable.first()[0];
        //                 var last = $focusable.last()[0];

        //                 if(e.shiftKey){

        //                     if(document.activeElement === first){

        //                         e.preventDefault();

        //                         last.focus();

        //                     }

        //                 }else{

        //                     if(document.activeElement === last){

        //                         e.preventDefault();

        //                         first.focus();

        //                     }

        //                 }

        //             }

        //             function updatePopup(){

        //                 /*
        //                 * Stop if the newsletter popup does not exist
        //                 * on this page.
        //                 */
        //                 if(!$popup.length){
        //                     return;
        //                 }

        //                 if(isOpen()){

        //                     $trigger.attr('aria-expanded','true');

        //                     var emailInput = $popup.find('input[type="email"]')[0];

        //                     if(emailInput && document.activeElement !== emailInput){

        //                         setTimeout(function(){

        //                             if(document.body.contains(emailInput)){
        //                                 emailInput.focus();
        //                             }

        //                         },100);

        //                     }

        //                 }else{

        //                     $trigger.attr('aria-expanded','false');

        //                     /*
        //                     * Only move focus if the opener exists.
        //                     */
        //                     if($openButton.length){

        //                         $openButton.trigger('focus');

        //                     }

        //                 }

        //             }


        //             /*
        //             * MutationObserver
        //             *
        //             * IMPORTANT:
        //             * Only observe the popup if it is actually
        //             * a DOM Node.
        //             */

        //             if($popup.length && $popup[0] instanceof Node){

        //                 var observer = new MutationObserver(function(){

        //                     updatePopup();

        //                 });

        //                 observer.observe($popup[0],{

        //                     attributes:true,

        //                     attributeFilter:[
        //                         'style',
        //                         'aria-hidden'
        //                     ]

        //                 });

        //             }else{

        //                 console.warn(
        //                     'Accessibility: #announcement-bar-newsletter was not found. MutationObserver was not initialized.'
        //                 );

        //             }


        //             /*
        //             * Keyboard focus trap
        //             */

        //             $(document).on('keydown',trapFocus);


        //             /*
        //             * Initial state
        //             */

        //             updatePopup();

        // });



    // ========================================= The review slider autoplay movement is not accessible. ====================
        (function(){function init(){
                var c=document.querySelector('.jdgm-carousel');if(!c)return false;
                var btn=c.querySelector('.jdgm-carousel__play-pause'),ic=c.querySelector('.jdgm-carousel__item-container');
                if(!btn||!ic)return false;
                if(!ic.id)ic.id='jdgm-carousel-slides';
                btn.classList.add('a11y-pp');btn.setAttribute('aria-controls',ic.id);
                var l=btn.querySelector('.a11y-pp__label');
                if(!l){l=document.createElement('span');l.className='a11y-pp__label';btn.appendChild(l);}
                var bar=c.querySelector('.a11y-pp-bar');
                if(!bar){bar=document.createElement('div');bar.className='a11y-pp-bar';ic.parentNode.insertBefore(bar,ic);}
                if(btn.parentNode!==bar)bar.appendChild(btn);
                function sync(){var p=btn.classList.contains('jdgm-carousel__play-pause--paused');
                    l.textContent=p?'Play reviews':'Pause reviews';
                    btn.setAttribute('aria-label',(p?'Play':'Pause')+' reviews carousel');}
                sync();new MutationObserver(sync).observe(btn,{attributes:true,attributeFilter:['class']});
                if(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches&&
                    !btn.classList.contains('jdgm-carousel__play-pause--paused'))btn.click();
                return true;}
                if(!init()){var n=0,t=setInterval(function(){if(init()||++n>40)clearInterval(t);},500);}
        })();


        /*!
    /* ========================================= Accessible mega menu — WCAG 2.2 AA ================================================================================== */
 
    
        (function () {
            'use strict';

            var CFG = {
                desktop:   '(min-width: 1000px)',
                menu:      '.tmenu_app.tmenu_app_desktop',
                rootItem:  '.tmenu_item--root.tmenu_item_has_child',
                active:    'tmenu_item_active',   // the app's own open-state class
                gutter:    16,                    // min gap from the viewport edge
                prerender: true,                  // render submenus once so aria-controls is always valid
                label:     function (text) { return '' + text + ' submenu'; }
            };

            var CHEVRON =
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" focusable="false" aria-hidden="true">' +
                '<path d="M256 294.1 383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 ' +
                '201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0z"/></svg>';

            var mql = window.matchMedia(CFG.desktop);
            var seq = 0, current = null, priming = false;

            /* ---------- helpers ---------- */

            // Only write when the value actually changes, otherwise the MutationObserver loops.
            function setAttr(el, n, v) { if (el.getAttribute(n) !== v) el.setAttribute(n, v); }
            function delAttr(el, n)    { if (el.hasAttribute(n)) el.removeAttribute(n); }

            function fire(el, type) {
                el.dispatchEvent(new MouseEvent(type, { bubbles: type === 'mouseover' || type === 'mouseout' }));
            }

            function submenuOf(item) {
                for (var i = 0; i < item.children.length; i++) {
                if (item.children[i].classList.contains('tmenu_submenu')) return item.children[i];
                }
                return null;
            }

            function tabbable(root) {
                var sel = 'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), ' +
                        'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
                return Array.prototype.filter.call(root.querySelectorAll(sel), function (el) {
                return el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
                });
            }

            function waitFor(item, test, done, frames) {
                frames = frames == null ? 60 : frames;
                var sub = submenuOf(item);
                if (sub && test(sub)) { done(sub); return; }
                if (frames <= 0)      { done(sub); return; }
                requestAnimationFrame(function () { waitFor(item, test, done, frames - 1); });
            }

            /* ---------- positioning ---------- */

            function position(item) {
                var sub = submenuOf(item);
                if (!sub || !mql.matches) return;

                var box  = item.closest(CFG.menu) || item.parentElement;
                var ir   = item.getBoundingClientRect();
                var br   = box.getBoundingClientRect();
                var w    = sub.offsetWidth;
                var vw   = document.documentElement.clientWidth;

                var min = Math.max(Math.min(br.left, vw - CFG.gutter - w), CFG.gutter);
                var max = Math.min(br.right, vw - CFG.gutter) - w;
                if (max < min) max = min;

                var left  = Math.min(Math.max(ir.left, min), max); // align to parent, then clamp
                var shift = Math.round(left - ir.left) + 'px';
                if (item.style.getPropertyValue('--tmenu-a11y-shift') !== shift) {
                item.style.setProperty('--tmenu-a11y-shift', shift);
                }
            }

            /* ---------- state ---------- */

            function sync(item) {
                var btn = item.__a11yToggle;
                if (!btn) return;

                var link = item.__a11yLink;
                var sub  = submenuOf(item);
                var open = !priming && item.classList.contains(CFG.active);

                setAttr(btn, 'aria-expanded', open ? 'true' : 'false');

                // The parent link is a link and nothing else.
                if (link) { delAttr(link, 'aria-expanded'); delAttr(link, 'aria-haspopup'); }

                if (sub) {
                if (!sub.id) sub.id = 'tmenu-submenu-' + (++seq);
                setAttr(btn, 'aria-controls', sub.id);
                if (open) delAttr(sub, 'aria-hidden');
                else if (!sub.contains(document.activeElement)) setAttr(sub, 'aria-hidden', 'true');
                }

                if (open) { current = item; position(item); }
                else if (current === item) { current = null; }
            }

            function open(item, moveFocus) {
                if (current && current !== item) close(current, false);

                // Let the app run its own open logic (it lazily renders the submenu).
                fire(item, 'mouseenter'); fire(item, 'mouseover');
                item.classList.add(CFG.active);
                sync(item);

                if (moveFocus) {
                waitFor(item, function (sub) { return tabbable(sub).length > 0; }, function (sub) {
                    sync(item);
                    if (!sub) return;
                    var list = tabbable(sub);
                    if (list.length) list[0].focus();
                });
                }
            }

            function close(item, returnFocus) {
                fire(item, 'mouseleave'); fire(item, 'mouseout');
                item.classList.remove(CFG.active);
                if (returnFocus && item.__a11yToggle) item.__a11yToggle.focus();
                sync(item);
            }

            /* ---------- enhancement ---------- */

            function enhance(item) {
                var link = item.querySelector(':scope > a');
                if (!link) return;

                // Vue rewrites class attributes, so state lives on a data-attribute it never touches.
                if (item.__a11yToggle) {
                setAttr(item, 'data-tmenu-a11y', item.__a11yToggleOnly ? 'toggle-only' : 'item');
                return;
                }

                var textEl = link.querySelector('.tmenu_item_text');
                var label  = ((textEl ? textEl.textContent : link.textContent) || '').replace(/\s+/g, ' ').trim();
                var href   = (link.getAttribute('href') || '').trim();
                var isLink = href && href !== '#' && !/^javascript:/i.test(href);

                delAttr(link, 'aria-expanded');
                delAttr(link, 'aria-haspopup');

                var btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'tmenu-a11y-toggle';
                btn.setAttribute('aria-expanded', 'false');
                btn.setAttribute('aria-haspopup', 'true');
                btn.setAttribute('aria-label', CFG.label(label));
                btn.innerHTML = CHEVRON;

                item.__a11yToggleOnly = !isLink;
                item.setAttribute('data-tmenu-a11y', isLink ? 'item' : 'toggle-only');

                // Parent has no destination: remove it from AT and the tab order, the button owns the item.
                if (!isLink) {
                setAttr(link, 'tabindex', '-1');
                setAttr(link, 'aria-hidden', 'true');
                }

                link.insertAdjacentElement('afterend', btn);
                item.__a11yToggle = btn;
                item.__a11yLink   = link;

                // <button> gives Enter and Space for free.
                btn.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                if (item.classList.contains(CFG.active)) close(item, false);
                else open(item, false);
                });

                btn.addEventListener('keydown', function (e) {
                if (e.key === 'ArrowDown') { e.preventDefault(); open(item, true); }
                });

                // Tabbing out of the item closes it, keeping the tab sequence linear.
                item.addEventListener('focusout', function (e) {
                if (e.relatedTarget && !item.contains(e.relatedTarget)) close(item, false);
                });

                sync(item);
            }

            function scan(menu) {
                Array.prototype.forEach.call(menu.querySelectorAll(CFG.rootItem), function (item) {
                enhance(item);
                sync(item);
                });
            }

            // The app renders submenus on first hover; render them once, invisibly,
            // so every toggle has a valid aria-controls target from the start.
            function prime(menu) {
                var pending = Array.prototype.filter.call(menu.querySelectorAll(CFG.rootItem), function (item) {
                return !submenuOf(item);
                });
                if (!pending.length) return;

                priming = true;
                menu.setAttribute('data-tmenu-a11y-prerender', '');

                var i = 0;
                (function next() {
                if (i >= pending.length) {
                    priming = false;
                    menu.removeAttribute('data-tmenu-a11y-prerender');
                    scan(menu);
                    return;
                }
                var item = pending[i++];
                fire(item, 'mouseenter'); fire(item, 'mouseover');
                waitFor(item, function () { return true; }, function () {
                    fire(item, 'mouseleave'); fire(item, 'mouseout');
                    item.classList.remove(CFG.active);
                    next();
                });
                })();
            }

            function init(menu) {
                if (menu.__a11yInit) return;
                menu.__a11yInit = true;

                scan(menu);

                menu.addEventListener('keydown', function (e) {
                if (e.key !== 'Escape' && e.key !== 'Esc') return;
                var item = e.target.closest ? e.target.closest(CFG.rootItem) : null;
                if (!item || !item.classList.contains(CFG.active)) item = current;
                if (item) { e.preventDefault(); e.stopPropagation(); close(item, true); }
                });

                // Re-enhance and re-sync after the app re-renders or opens a menu on hover.
                var queued = false;
                new MutationObserver(function () {
                if (queued) return;
                queued = true;
                requestAnimationFrame(function () { queued = false; scan(menu); });
                }).observe(menu, {
                subtree: true, childList: true,
                attributes: true, attributeFilter: ['class', 'aria-expanded', 'aria-haspopup']
                });

                if (CFG.prerender && mql.matches) {
                (window.requestIdleCallback || function (fn) { setTimeout(fn, 1200); })(
                    function () { prime(menu); }, { timeout: 2000 }
                );
                }
            }

            function boot() {
                Array.prototype.forEach.call(document.querySelectorAll(CFG.menu), init);
            }

            document.addEventListener('click', function (e) {
                if (current && !current.contains(e.target)) close(current, false);
            });
            window.addEventListener('resize', function () { if (current) position(current); });

            if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
            else boot();

            // The app initialises asynchronously; catch late menus.
            new MutationObserver(boot).observe(document.documentElement, { subtree: true, childList: true });
        })();


    /* ========= BidetKing product page — two cart-related fixes  A. Mini cart returns focus to whatever opened it (cart icon, Add to cart, …) B. Enter on a variant selector no longer adds the product to the cart */
        (function () {
            if (window.__cartA11yInit) return;
            window.__cartA11yInit = true;

            /* =========================================================
                A. Mini cart focus return
                The mini cart (#mini-cart, role="dialog") traps focus correctly and
                toggles aria-hidden, but stores no return point — closing it drops
                focus on <body>. WCAG 2.4.3 Focus Order.
                ========================================================= */

            var MINI = '#mini-cart';
            var cart = document.querySelector(MINI);
            var wasOpen = cart ? cart.getAttribute('aria-hidden') === 'false' : false;
            var returnTo = null;
            var lastOutside = null;

            function inCart(el) { return cart && el && cart.contains(el); }

            // Track the last element focused OUTSIDE the mini cart. Tracking this
            // continuously (rather than reading activeElement at open time) survives the
            // Add to cart button being disabled during its AJAX request — which drops
            // focus to <body> before the cart ever opens.
            document.addEventListener('focusin', function (e) {
                var t = e.target;
                if (!t || t === document.body || t === document.documentElement) return;
                if (inCart(t)) return;
                lastOutside = t;
            }, true);

            document.addEventListener('pointerdown', function (e) {
                var t = e.target && e.target.closest &&
                e.target.closest('a[href],button,[role="button"],input,select,textarea,[tabindex]');
                if (t && !inCart(t)) lastOutside = t;
            }, true);

            function onCartOpen() {
                returnTo = lastOutside;

                // Opening via "Add to cart" leaves focus on <body>: the theme only moves
                // focus in on the header-icon path. That also breaks Escape, which the
                // theme binds inside the dialog — the cart opens and the keyboard user is
                // stranded outside it. Move focus in ourselves when it isn't already.
                if (!cart || inCart(document.activeElement)) return;
                if (!cart.hasAttribute('tabindex')) cart.setAttribute('tabindex', '-1');
                var tries = 0;
                (function enter() {
                try { cart.focus({ preventScroll: true }); } catch (e) {}
                if (inCart(document.activeElement)) return;
                if (tries++ < 10) setTimeout(enter, 50);
                })();
            }

            function onCartClose() {
                var t = returnTo;
                returnTo = null;
                if (!t) return;
                if (!document.body.contains(t)) return;      // re-rendered away

                // Settle first. A click outside dismisses the cart on mousedown, before the
                // browser has moved focus to whatever was clicked, so deciding immediately
                // would read a stale activeElement and yank focus off the user's target.
                setTimeout(function () {
                var a = document.activeElement;
                // user put focus somewhere themselves — leave it alone
                if (a && a !== document.body && a !== document.documentElement && !inCart(a)) return;
                var tries = 0;
                (function restore() {
                    try { t.focus({ preventScroll: true }); } catch (e) {}
                    if (document.activeElement === t) return;
                    if (tries++ < 12) { setTimeout(restore, 50); return; }
                    try {                                     // rather than leaving focus on <body>
                    if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
                    t.focus({ preventScroll: true });
                    } catch (e) {}
                })();
                }, 120);
            }

            new MutationObserver(function () {
                var el = document.querySelector(MINI);
                if (el !== cart) {                            // cart section re-rendered
                cart = el;
                wasOpen = cart ? cart.getAttribute('aria-hidden') === 'false' : false;
                return;
                }
                if (!cart) return;
                var open = cart.getAttribute('aria-hidden') === 'false';
                if (open === wasOpen) return;
                wasOpen = open;
                if (open) onCartOpen(); else onCartClose();
            }).observe(document.documentElement, {
                subtree: true, attributes: true,
                attributeFilter: ['aria-hidden', 'class', 'style']
            });

            /* =========================================================
                B. Enter on a variant selector must not submit the form
                Size / Remote Color / Warranty are radios inside the /cart/add form, so
                Enter triggers implicit form submission — the browser activates the
                default submit button ("Add to cart") and the item is added. Space and
                the arrow keys already select variants; Enter has no defined role on a
                radio, so suppressing it removes an unintended, destructive action
                without taking any expected behaviour away.

                Scoped deliberately: the quantity field keeps its normal Enter-to-submit.
                ========================================================= */

            var VARIANT = 'input[type="radio"][name^="option"],' +
                            'input[type="checkbox"][name^="option"],' +
                            'select[name^="option"],' +
                            '.product-form__single-selector';

            document.addEventListener('keydown', function (e) {
                if (e.key !== 'Enter') return;
                var t = e.target;
                if (!t || !t.matches || !t.matches(VARIANT)) return;
                var f = t.form;
                if (!f || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
                e.preventDefault();          // block implicit submission only
            }, true);
        })();












    /* BidetKing mobile navigation — keyboard-operable submenus */
        (function () {
        if (window.__mobileSubmenuA11y) return;
        window.__mobileSubmenuA11y = true;

        var MENU = '#mobile-menu';
        var ITEM = 'li.tmenu_item_has_child';
        var uid = 0;

        var style = document.createElement('style');
        style.textContent =
            '#mobile-menu li.tmenu_item_has_child{position:relative}' +
            '#mobile-menu .a11y-subtoggle{position:absolute;top:0;right:0;width:52px;' +
            'min-height:44px;background:transparent;border:0;padding:0;margin:0;' +
            'cursor:pointer;z-index:3}' +
            '#mobile-menu .a11y-subtoggle:focus{outline:2px solid currentColor;outline-offset:-4px}' +
            '#mobile-menu .a11y-subtoggle:focus:not(:focus-visible){outline:none}' +
            '.a11y-sr-only{position:absolute!important;width:1px;height:1px;margin:-1px;' +
            'padding:0;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);' +
            'white-space:nowrap;border:0}';
        document.head.appendChild(style);

        // Write only when the value actually changes. setAttribute fires a mutation
        // record even when it writes an identical value, and this script observes
        // aria-expanded — without this guard the observer re-triggers itself forever
        // and locks up the page.
        function setAttr(el, name, value) {
            if (el.getAttribute(name) !== value) el.setAttribute(name, value);
        }

        function ownLink(li) { return li.querySelector(':scope > a.tmenu_item_link'); }
        function ownSub(li)  { return li.querySelector(':scope > ul'); }

        function nameOf(li) {
            var a = ownLink(li);
            if (!a) return 'Submenu';
            var t = a.querySelector('.tmenu_item_text');
            return ((t ? t.textContent : a.textContent) || '').trim() || 'Submenu';
        }

        function enhance(li) {
            var a = ownLink(li);
            var ind = a && a.querySelector('.tmenu_indicator');
            if (!a || !ind) return;

            var btn = li.querySelector(':scope > button.a11y-subtoggle');
            if (!btn) {
            btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'a11y-subtoggle';
            btn.setAttribute('aria-expanded', 'false');
            var sr = document.createElement('span');
            sr.className = 'a11y-sr-only';
            sr.textContent = nameOf(li) + ' submenu';
            btn.appendChild(sr);
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                ind.click();            // hand off to the menu app's own toggle
            });
            a.insertAdjacentElement('afterend', btn);
            }

            // cover the chevron, matching the row (not the row plus its open submenu)
            var h = a.offsetHeight;
            if (h && btn.style.height !== h + 'px') btn.style.height = h + 'px';

            // The app writes aria-expanded onto the LINK. Read it, mirror it onto the
            // button that can actually be operated, then take it off the link — a
            // control that reports an expanded state it cannot change is a 4.1.2
            // problem, and the app keeps its own state in JS, not in the attribute.
            if (a.hasAttribute('aria-expanded')) {
            var v = a.getAttribute('aria-expanded') === 'true' ? '1' : '0';
            if (li.dataset.a11yExpanded !== v) li.dataset.a11yExpanded = v;
            a.removeAttribute('aria-expanded');
            }
            if (a.hasAttribute('aria-haspopup')) a.removeAttribute('aria-haspopup');

            var sub = ownSub(li);
            if (sub) {
            if (!sub.id) sub.id = 'a11y-submenu-' + (++uid);
            setAttr(btn, 'aria-controls', sub.id);
            }

            var open = li.dataset.a11yExpanded === '1';
            setAttr(btn, 'aria-expanded', open ? 'true' : 'false');

            // A collapsed submenu is only visually hidden, so its links stay in the tab
            // order and a screen reader still reaches them. Take it out of the tree.
            if (sub) {
            var isInert = sub.hasAttribute('inert');
            if (open && isInert) sub.removeAttribute('inert');
            else if (!open && !isInert) {
                try { sub.inert = true; } catch (e) { sub.setAttribute('inert', ''); }
            }
            }
        }

        function apply() {
            var menu = document.querySelector(MENU);
            if (!menu) return;
            [].slice.call(menu.querySelectorAll(ITEM)).forEach(enhance);
        }

        // Escape collapses the innermost open submenu and returns focus to its button
        document.addEventListener('keydown', function (e) {
            if (e.key !== 'Escape') return;
            var menu = document.querySelector(MENU);
            if (!menu || !document.activeElement) return;
            if (!menu.contains(document.activeElement)) return;
            var li = document.activeElement.closest(ITEM);
            if (li && li.dataset.a11yExpanded !== '1' && li.parentElement) {
            li = li.parentElement.closest(ITEM);
            }
            if (!li || li.dataset.a11yExpanded !== '1') return;
            var btn = li.querySelector(':scope > button.a11y-subtoggle');
            if (!btn) return;
            e.preventDefault();
            e.stopPropagation();        // don't let the whole drawer close too
            btn.click();
            btn.focus();
        }, true);

        var queued = false;
        function schedule() {
            if (queued) return;
            queued = true;
            requestAnimationFrame(function () { queued = false; apply(); });
        }

        apply();
        new MutationObserver(schedule).observe(document.documentElement, {
            childList: true, subtree: true,
            attributes: true, attributeFilter: ['aria-expanded', 'class']
        });
        })();





});